@if (switchingData()) {
    <div class="payin-payout-switching" *transloco="let i18n">
        <mat-slide-toggle
            #togglePayin="matSlideToggle"
            [hideIcon]="true"
            [checked]="switchingData()?.payinActive"
            (toggleChange)="changeSwitch(togglePayin, PaymentDirections.PAY_IN)"
        >{{ i18n('payment.Payment.Switching.SlideTitle.Payin') }}</mat-slide-toggle>
        <mat-slide-toggle
            #togglePayout="matSlideToggle"
            [hideIcon]="true"
            [checked]="switchingData()?.payoutActive"
            (toggleChange)="changeSwitch(togglePayout, PaymentDirections.PAY_OUT)"
        >{{ i18n('payment.Payment.Switching.SlideTitle.Payout') }}</mat-slide-toggle>
    </div>
}
